import * as React from "react"
import parse from "html-react-parser"
import { useStaticQuery, graphql } from "gatsby"
import Image from "./atoms/image"
import Toc from "./articleContent/toc"
import Balloon from "./articleContent/balloon"
import BlogCard from "./articleContent/blogCard"
import Cv from "./articleContent/cv"

const ArticleContent = ({ contents }) => {
  const content = mergeContents(contents)
  const data = useStaticQuery(graphql`
    query siteData {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)
  const replace = node => {
    // 画像
    if (node.name === "img") {
      const url = node.attribs.src
      const width = node.attribs.width
      const alt = node.attribs.alt
      return <Image url={url} width={width} alt={alt} />
    }
    // リンク
    if (node.name === "p") {
      if (node.children && node.children[0].name === "a") {
        const url = node.children[0].attribs.href
        if (url.indexOf(data.site.siteMetadata.siteUrl) !== -1) {
          const pattern = new RegExp("/([^/]+)/?$", "i")
          const result = pattern.exec(url)
          return <BlogCard slug={result[1]} />
        }
      }
    }
    // 目次
    if (node.name === "toc") {
      return <Toc content={content} />
    }
    // 吹き出し
    if (node.name === "balloon") {
      const text = node.attribs.text
      const isMine = node.attribs.ismine
      const name = node.attribs.name
      return <Balloon text={text} isMine={isMine} name={name} />
    }
    // CVボックス
    if (node.name === "cv") {
      const title = node.attribs.title
      const point = node.attribs.point.split(",")
      const img = node.attribs.img
      const url = node.attribs.url
      const score = node.attribs.score.split(",").map(node => {
        return node.split(":")
      })
      return (
        <Cv img={img} title={title} point={point} score={score} url={url} />
      )
    }
    // 埋め込み
    if (node.name === "iframe") {
      return (
        <div
          className="relative w-full h-0"
          style={{ paddingBottom: "56.25%" }}
        >
          <iframe
            className="top-0 left-0 w-full h-full absolute"
            title={node.attribs.title}
            {...node.attribs}
          ></iframe>
        </div>
      )
    }
  }
  return <div className="content mt-8">{parse(content, { replace })}</div>
}

const mergeContents = contents => {
  let str = ""
  contents.forEach(elm => {
    if (elm.html != null) {
      str += elm.html
    } else {
      str += elm.rich
    }
  })
  return str
}

export default ArticleContent
